import { gql } from '@apollo/client';

export const GET_BUILDER_CONFIG = gql`
    query GetBuilderConfig {
        config {
            id
            features {
                builder {
                    builderTemplateDrafts
                    multiImageTemplates
                }
            }
        }
    }
`;
